import { Box, Button, Heading, Text, Tooltip, VStack } from 'native-base'

export enum LoginMethod {
  MAGIC_LINK = 'MAGIC_LINK',
  PASSWORD = 'PASSWORD',
}

const ChooseLoginMethod = ({ methods, callback }) => {
  const doCallback = (method) => {
    callback(method)
  }

  const isDisabled = (method) => {
    return methods && methods.every((m) => m !== method)
  }

  return (
    <VStack h="100%" w="100%" style={{ gap: 12 }}>
      <Heading fontSize={'2xl'} mt="3" color="primary.900">
        Welcome back!
      </Heading>
      <Text alignSelf="center" fontSize={'md'}>
        Choose your verification method.
      </Text>
      <VStack style={{ gap: 6 }}>
        <Button
          isDisabled={isDisabled(LoginMethod.MAGIC_LINK)}
          onPress={() => doCallback(LoginMethod.MAGIC_LINK)}>
          Email me a login link
        </Button>
        <Tooltip
          label="You can set a password from the account settings screen once you've logged in."
          isDisabled={!isDisabled(LoginMethod.PASSWORD)}>
          <Box>
            <Button
              isDisabled={isDisabled(LoginMethod.PASSWORD)}
              onPress={() => doCallback(LoginMethod.PASSWORD)}>
              Continue with a password
            </Button>
          </Box>
        </Tooltip>
      </VStack>
    </VStack>
  )
}

export default ChooseLoginMethod
